import { atom } from "recoil"

export const draftContactsRequestIdState = atom({
  key: "atoms/contact/draftContactsRequestIdState",
  default: 0,
})
